// src/components/profile/SocialLinks.js
import React from 'react';
import styles from '../../styles/pages/About.module.css';

/**
 * Social media links component that can be reused across pages
 * 
 * @param {Object} props - Component props
 * @param {Array} [props.links] - Array of social media link objects
 */
export function SocialLinks({ links }) {
  // Default links if none provided
  const defaultLinks = [
    { url: "https://github.com/thatrandomfrenchdude", label: "GitHub" },
    { url: "https://linkedin.com/in/debeurre", label: "LinkedIn" },
    // { url: "https://twitter.com/thatrandomfrenchdude", label: "Spotify" },
  ];
  
  // Use provided links or fall back to defaults
  const socialLinks = links || defaultLinks;
  
  return (
    <div className={styles.socialLinks}>
      {socialLinks.map((link, index) => (
        <a 
          key={index} 
          href={link.url} 
          target="_blank" 
          rel="noopener noreferrer"
        >
          {link.label}
        </a>
      ))}
    </div>
  );
}